// extracted by mini-css-extract-plugin
module.exports = {"CirclePointDiagram":"CirclePointDiagram","combineScoreText":"combineScoreText","svgContainer":"svgContainer"};